export default {"src":"/_next/static/media/entretien-des-massifs.cb2cd3b5.svg","height":64,"width":104,"blurWidth":0,"blurHeight":0};